<template>
  <div class="row layouts">
    <div class="col-md-12 mt-2">
      <div class="card">
        <b-row v-if="isError" class="justify-content-center mt-2">
          <b-col lg="10">
            <b-alert variant="danger" show dismissible>
              Opps .. Something is wrong
            </b-alert>
          </b-col>
        </b-row>
        <div class="card-body">
          <div class="row justify-content-end">
            <label for="" class="col-sm-auto">Count </label>
            <strong class="col-sm-auto">{{ formatPriceBasic(totalRows) }}</strong>
          </div>
          <b-table
            responsive
            hover
            :items="items"
            :busy="isLoading"
            :isLoading="isLoading"
            :fields="fields"
            show-empty
          >
            <template #cell(No)="row">
              {{ (currentPage - 1) * perPage + (row.index + 1)}}
            </template>
            <template #cell(name)="row">
              <div>
                {{ row.item.author ? row.item.author.name:'' }}
              </div>
            </template>
            <template #cell(createdBy)="row">
              <div>
                {{ row.item.pic ? row.item.pic.name : '' }}
              </div>
            </template>
            <template #cell(created)="row">
              <div>
                {{ formatDate(row.item.created) }}
              </div>
            </template>
             <template #cell(modified)="row">
              <div>
                {{ formatDate(row.item.modified) }}
              </div>
            </template>
            <template #cell(action)="row">
              <button class="btn btn-sm btn-danger" @click="actionConfirm(row.item)">
                <i class="fa fa-trash-o"></i> Delete
              </button>
            </template>
            <template v-slot:table-busy>
              <div class="text-center text-dark my-2">
                <svg class="heart" viewBox="0 0 32 29.6">
                  <path
                    d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                    c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z"
                  />
                </svg>
                Loading ...
              </div>
            </template>
          </b-table>
        </div>
        <b-row class="justify-content-start ml-1">
          <b-col lg="3">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import API from "../../plugins/http"
export default {
  name: "AuthorPopular",
  data() {
    return {
      currentPage: 1,
      perPage: 100,
      filter: null,
      isLoadingSearch: false,
      items_search: [],
      fields: [
        { key:'No', label: 'No'},
        { key:'name', label: 'Author Name'},
        { key:'rating', label: 'Rating'},
        { key:'sort_priority', label: 'Sort Priority'},
        { key:'createdBy', label: 'Created By'},
        { key:'updatedBy', label: 'Updated By'},
        { key:'created', label: 'Created At'},
        { key:'modified', label: 'Modified At'},
        { key:'action', label: 'Action'},
      ]
    };
  },
  watch: {
    currentPage: function() {
      this.actionFetchAuthorPopular();
    },
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.authorPopular.isLoading,
      isError: (state) => state.authorPopular.isError,
      totalRows: (state) => state.authorPopular.totalRows,
			items: (state) => state.authorPopular.populars,
    }),
  },
  mounted() {
    this.actionFetchAuthorPopular();
  },
  methods: {
    ...mapActions("authorPopular", ["fetch","fetchByID"]),
    actionFetchAuthorPopular() {
      this.fetch();
    },
    actionConfirm(data){
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            API.delete('author-popular',data.id)
            .then(() => {
              this.$swal({
                toast: "true",
                position: "top-end",
                icon: "success",
                title: "Sucess UnBanned",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              })
              this.actionFetchAuthorPopular();
            }).catch(()=> {
               this.$swal({
                toast: "true",
                position: "top-end",
                icon: "error",
                title: "Failed UnBanned",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              })
            })
          }
        });
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style scoped>
</style>
